import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "px-5 py-4 bg-play-gray" }
const _hoisted_2 = ["alt", "src"]
const _hoisted_3 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_4 = { class: "text-3xl" }
const _hoisted_5 = { class: "py-3" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 1,
  class: "px-4 my-8"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "flex items-center justify-between" }
const _hoisted_10 = { class: "text-xl" }
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2.4 5L0 7.33333L9.6 16.6667L12 19L14.4 16.6667L24 7.33333L21.6 5L12 14.3333L2.4 5Z\" fill=\"black\"></path><mask id=\"mask0_0_4024\" style=\"mask-type:luminance;\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"5\" width=\"24\" height=\"14\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2.4 5L0 7.33333L9.6 16.6667L12 19L14.4 16.6667L24 7.33333L21.6 5L12 14.3333L2.4 5Z\" fill=\"white\"></path></mask><g mask=\"url(#mask0_0_4024)\"><rect width=\"24\" height=\"24\" fill=\"black\"></rect></g></svg>", 1)
const _hoisted_12 = ["id"]
const _hoisted_13 = ["innerHTML"]


import RichTextResolver from "storyblok-js-client/richTextResolver";


export default /*#__PURE__*/_defineComponent({
  __name: 'StoryblockDescription',
  props: {
  story: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const resolver = new RichTextResolver();


function resolve(data: Object) {
  try {
    return resolver.render(data);
  } catch (e) {
    return null;
  }
}

function toggleAccordionItem(index: number) {
  console.log("trigger");
  const item = document.getElementById(`accordion-item-${index}`);

  if (item?.classList.contains("hidden")) {
    item?.classList.remove("hidden");
  } else {
    item?.classList.add("hidden");
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.story.content && __props.story.content.image)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "w-1/3 mx-auto",
          alt: __props.story.content.image.alt,
          src: __props.story.content.image.filename
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true),
    (__props.story.content.sections)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.story.content.sections, (section) => {
            return (_openBlock(), _createElementBlock("div", { key: section }, [
              _createElementVNode("h2", _hoisted_4, _toDisplayString(section.heading), 1),
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.content, (component) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: component._uid
                  }, [
                    (component.component == 'rich-text')
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          innerHTML: resolve(component.content)
                        }, null, 8, _hoisted_6))
                      : _createCommentVNode("", true),
                    (component.component === 'accordion')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(component.accordionItems, (item, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              onClick: ($event: any) => (toggleAccordionItem(index)),
                              class: "border-b-2 border-black py-7 hover:cursor-pointer",
                              key: item
                            }, [
                              _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("h2", _hoisted_10, _toDisplayString(item.heading), 1),
                                _hoisted_11
                              ]),
                              _createElementVNode("div", {
                                class: "hidden py-3",
                                id: `accordion-item-${index}`
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.content, (component) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: component._uid
                                  }, [
                                    _createElementVNode("div", {
                                      innerHTML: resolve(component.content)
                                    }, null, 8, _hoisted_13)
                                  ]))
                                }), 128))
                              ], 8, _hoisted_12)
                            ], 8, _hoisted_8))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})